// Page publique (sans connexion) ouverte par le QR code d'un BL.
import React, { useEffect, useState } from 'react';
import { Alert, Box, Container, Paper, TextField, Button, Typography } from '@mui/material';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { blAPI } from '../services/api';
import { dateFr, dateHeureFr } from '../utils/format';

const VerifierBL = () => {
  const { numero } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [input, setInput] = useState({ numero: numero || '', code: params.get('code') || '' });

  useEffect(() => {
    if (!numero) return;
    setResult(null); setError('');
    blAPI.verify(numero, params.get('code'))
      .then((r) => setResult(r.data))
      .catch((err) => setError(err.response?.data?.message || err.response?.data?.error || 'Vérification impossible'));
  }, [numero, params]);

  const submit = (e) => {
    e.preventDefault();
    const n = input.numero.trim().toUpperCase();
    if (n) navigate(`/verifier/${encodeURIComponent(n)}${input.code ? `?code=${encodeURIComponent(input.code.trim().toUpperCase())}` : ''}`);
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <img src="/logo-docc.png" alt="DOCC" style={{ height: 90 }} />
          <Typography variant="h5" sx={{ mt: 1 }}>Vérification d'un bon de livraison</Typography>
        </Box>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {result && (
          <Alert severity={result.valide ? 'success' : 'error'} sx={{ mb: 2 }}>
            <strong>{result.message}</strong>
          </Alert>
        )}
        {result && (
          <Box sx={{ mb: 3, '& p': { my: 0.5 } }}>
            <p><b>N° BL :</b> {result.numero}</p>
            <p><b>Date de livraison :</b> {dateFr(result.date_livraison)}</p>
            <p><b>Client :</b> {result.client}</p>
            {result.destination && <p><b>Destination :</b> {result.destination}</p>}
            <p><b>Total poteaux :</b> {result.total_poteaux} U</p>
            {result.scelle_le && <p><b>Scellé le :</b> {dateHeureFr(result.scelle_le)}</p>}
            {result.code_verification && <p><b>Code de vérification :</b> <code>{result.code_verification}</code></p>}
          </Box>
        )}

        <Box component="form" onSubmit={submit}>
          <Typography variant="subtitle2" gutterBottom>Vérifier un autre BL</Typography>
          <TextField fullWidth size="small" label="N° BL (ex. BL-2026-000521)" sx={{ mb: 1 }}
            value={input.numero} onChange={(e) => setInput({ ...input, numero: e.target.value })} />
          <TextField fullWidth size="small" label="Code de vérification (ex. 3B25-D3D4-2E30)" sx={{ mb: 1 }}
            value={input.code} onChange={(e) => setInput({ ...input, code: e.target.value })} />
          <Button type="submit" variant="contained" fullWidth>Vérifier</Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default VerifierBL;
